<script setup lang="ts">
/**
 * Tous les QR codes d'une association — page publique « tout lister », partageable telle quelle.
 * Voir `AssoListeFeature` pour le pourquoi.
 */
const slug = (useRoute().params as { slug: string }).slug;
const { t } = useI18n();
</script>

<template>
  <AssoListeFeature
    :slug="slug"
    domaine="qr-codes"
    :titre="t('association.listeQrCodes.titre')"
    :sous-titre="t('association.listeQrCodes.sousTitre')"
    :message-vide="t('association.listeQrCodes.messageVide')"
  />
</template>
